import { Route, Routes } from "react-router-dom";
import Homepage from "./Components/home.jsx";
import Header from "./Components/header.jsx";
import About from "./page/aboutpage.jsx";
import Blog from "./page/blogpage.jsx";
import Service from "./page/servicepage.jsx";
import Contact from "./page/contact.jsx";
import Register from "./page/Registationpage.jsx";
import Footer from "./Components/footer.jsx";
import Partner from "./page/partner.jsx";
import AIlot from "./page/solutionpage/AI.jsx";
import Cloud from "./page/solutionpage/cloudpage.jsx";
import Cyber from "./page/solutionpage/Cybersecurity.jsx";
import Infastructure from "./page/solutionpage/infa.jsx";
import Networking from "./page/solutionpage/Networkpage.jsx";
import Software from "./page/solutionpage/softwarepage.jsx";
import Customer from "./page/customer.jsx";

function App() {
  return (
    <div className="app-container">
      {/* Common Components */}
      <Header />

      <div className="content">
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/about" element={<About />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/partners" element={<Partner />} />
          <Route path="/register" element={<Register />} />
          <Route path="/customer" element={<Customer/>} />

          {/* Solution Routes */}
          <Route path="/solution" element={<Service />} />
          <Route path="/solution/AI&LOT" element={<AIlot />} />
          <Route path="/solution/Cloud-solution" element={<Cloud />} />
          <Route path="/solution/CyberSecurity-solution" element={<Cyber />} />
          <Route path="/solution/Infastructure-solution" element={<Infastructure />} />
          <Route path="/solution/Networking-solution" element={<Networking />} />
          <Route path="/solution/Software-Solution" element={<Software />} />
        </Routes>
      </div>

      {/* Footer stays static */}
      <Footer />
    </div>
  );
}

export default App;
